import { render } from "./index.vue?vue&type=template&id=99237d92&ts=true"
import script from "./game-lobby.ts?vue&type=script&lang=ts"
export * from "./game-lobby.ts?vue&type=script&lang=ts"

import "./game-lobby.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\Devin\\Desktop\\drawing app\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__